<template>
  <link-fi
    v-if="cadUrl"
    :href="cadUrl"
    :size="18"
    target="_blank"
    @click="onCadLinkClicked"
  >
    {{ fields.cadLinkText?.value }}
  </link-fi>
</template>

<script setup lang="ts">
import { LinkFi } from 'atoms';

import type { SingleLineTextField } from '@/sitecoreFieldTypes';

// A whole page's fields are passed in, so this one need not be filled.
interface CadLinkFields {
  cadLinkText?: SingleLineTextField;
}

interface Props {
  fields: CadLinkFields;
  openInDialog?: boolean;
  cadUrl?: string | null;
}

interface Emits {
  (e: 'open-cad-details-dialog'): void;
}

const props = withDefaults(defineProps<Props>(), {
  openInDialog: false,
  cadUrl: null,
});

const emit = defineEmits<Emits>();

const onCadLinkClicked = (e: MouseEvent) => {
  if (!props.openInDialog) {
    return;
  }
  e.preventDefault();

  emit('open-cad-details-dialog');
};
</script>
